import type { Action } from "../../actions/types";

export type StoreState = string;

export const initialState = "localhost:9988/prod";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_ROOT_URL") {
    return action.data;
  }

  return state;
}
